import { Component } from '@angular/core';
import { CellRendererComponent } from '@valg-shared/components/table/directives/cell-component-outlet/cell-component-outlet.directive';
import { getValueAt } from '@valg-shared/utils/object-utils';
import { Column } from '@valg-shared/components/table/table/column';
@Component({
  selector: 'valg-dk-bar-chart-renderer',
  templateUrl: './bar-chart-renderer.component.html',
})
export class BarChartRendererComponent implements CellRendererComponent {
  value?: number;
  text = '';
  number!: number;
  isQuantityChart = false;
  defaultValue = '';
  shouldRenderBarChart = false;

  public init(data: unknown, column: Column): void {
    const rawValue = getValueAt(data, column.path);

    // Only set value and render the bar chart if rawValue is a valid number
    if (typeof rawValue === 'number') {
      this.value = rawValue;
      this.shouldRenderBarChart = true;
    } else {
      this.value = undefined;
      this.shouldRenderBarChart = false;
    }

    const options: Map<string, string | boolean> | undefined = column.metadata?.rendererOptions;
    if (options) {
      this.setText(data, options);
      this.setNumber(data, options);

      const defaultValueOption = options.get('defaultValue') as string | undefined;
      this.defaultValue = defaultValueOption || '-';
    }
  }

  private setText(data: unknown, options: Map<string, string | boolean>): void {
    const textPath = options.get('textPath') as string | undefined;
    const text = typeof textPath === 'string' ? getValueAt(data, textPath) : undefined;
    this.text = text !== undefined && text !== null ? String(text) : '';
  }

  private setNumber(
    data: unknown,
    options: Map<string, string | boolean>
  ): void {
    const numberPath = options.get('numberPath') as string | undefined;
    if (typeof numberPath === 'string') {
      const number = getValueAt(data, numberPath);
      this.number = number !== undefined && number !== null ? number : 0;
      this.isQuantityChart = true;
    }
  }
}
